import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";

// Handles the return leg of Emergent Google sign-in ({app}/dashboard#session_id=...)
export default function AuthCallback() {
  const nav = useNavigate();
  const location = useLocation();
  const { updateUser } = useAuth();
  const hasProcessed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const m = (location.hash || "").match(/session_id=([^&]+)/);
    const sessionId = m ? m[1] : null;
    if (!sessionId) {
      nav("/login", { replace: true });
      return;
    }
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sessionId });
        localStorage.setItem("sohom_token", data.token);
        updateUser(data.user);
        window.history.replaceState(null, "", "/dashboard");
        nav("/dashboard", { replace: true, state: { user: data.user } });
      } catch (err) {
        window.history.replaceState(null, "", "/login");
        setError(formatApiError(err));
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen grid place-items-center bg-zinc-50 p-6">
      <div className="w-full max-w-sm bg-white border border-zinc-200 rounded-lg p-8 text-center" data-testid="auth-callback-card">
        <div className="mx-auto h-12 w-24 rounded-md bg-white border border-zinc-200 grid place-items-center overflow-hidden px-1 mb-4">
          <img src="/soham-logo.jpg" alt="Soham Express logo" className="h-full w-full object-contain" />
        </div>
        {error ? (
          <>
            <div className="text-sm text-rose-700 bg-rose-50 border border-rose-200 rounded-md px-3 py-2" data-testid="auth-callback-error">
              {error}
            </div>
            <Button onClick={() => nav("/login", { replace: true })} data-testid="auth-callback-back-btn"
              className="mt-4 w-full bg-blue-600 hover:bg-blue-700 text-white">
              Back to sign in
            </Button>
          </>
        ) : (
          <div className="text-sm text-zinc-600 font-mono" data-testid="auth-callback-loading">
            Signing you in with Google…
          </div>
        )}
      </div>
    </div>
  );
}
